<template>
    <div style="direction:rtl">
        <CCard>
            <CCardHeader d>
                <h3 class="card-title">ثبت</h3>
                <div style="display:flex;gap:10px;direction:ltr">
                    <CButton @click="DialogAddViolation = true" color="primary">افزودن</CButton>
                    <CButton @click="DialogAddGroupViolation = true" color="primary" > افزودن گروهی</CButton>
                </div>
            </CCardHeader>
            <CCardBody>
                <div style="display:flex;height:65vh">
                    <div style="width:100%;height:65vh;">
                        <CDataTable
                            :hover="true"
                            :border="true"
                            
                            :striped="true"
                            :small="true"
                            :items="$store.state.Violation_GetTop10ByUserID.RequestResponse"
                            :fields="fields"
                            :fixed="true"
                            :loading="false"
                            :items-per-page="10"
                            pagination
                            :columnFilter='{}'
                            :noItemsView="{ noResults: 'چیزی یافت نشد.', noItems: 'چیزی برای نمایش وجود ندارد.' }"
                        >
                            <template #Rows="{index}">
                                <td >
                                    {{index+1}}
                                </td>
                            </template>
                            <template #ViolationTS="{item}">
                                <td style="direction:ltr">
                                    {{GetDateTime(item.ViolationTS)}}
                                </td>
                            </template>

                            <template #Edit="{item}">
                                <td >
                                    <CButton @click="Edit(item)" color="info">ویرایش</CButton>
                                </td>
                            </template>
                            <template #Delete="{item}">
                                <td >
                                    <CButton @click="Violation_Delete(item)" color="danger">حذف</CButton>
                                </td>
                            </template>
                        </CDataTable>
                    </div>
                    
                </div>
            </CCardBody>
             <CCardFooter style="display:flex;direction:ltr;gap:10px">
                
                <MPrint 
                    v-if="$store.state.Violation_GetTop10ByUserID.RequestResponse.length>0"
                    :data="$store.state.Violation_GetTop10ByUserID.RequestResponse"
                    :fields="fields"
                    label="PDF" title="آخرین تخلفات">
                </MPrint>
            </CCardFooter>
        </CCard>

        <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'sm'"
                :show.sync="DialogAddViolation"
        >
            <div style="direction: rtl;text-align: right">
                <CRow>
                    <CSelect label="انتخاب خط"   :options="GetOtions($store.state.Fleets.RequestResponse)"   :value.sync="Violation.FleetID" @change="ChangeFleet"   style="color: white" > </CSelect>
                    <CSelect label="انتخاب خودرو"    :options="GetOtionsDevice($store.state.Devices.RequestResponse)"  :value.sync="Violation.indexDeviceID"   style="color: white" > </CSelect>
                    <CSelect label="نوع تخلف" :options="GetOtionsViolation($store.state.ViolationList_GetAll.RequestResponse)"   :value.sync="Violation.ViolationID"    style="color: white" > </CSelect>
                    <label for="stTime" style="color:white">زمان تخلف</label> 
                    <date-picker style="width:330px;" v-model="Violation.ViolationTS"  id="stTime"  aria-label="تاریخ" auto-submit  type="datetime"></date-picker>
                    <CTextarea
                        label="توضیحات"
                        valid-feedback=""
                        invalid-feedback="حداقل چهار  کارکتر  می باشد."
                        value="Valid value"
                        rows="4"
                        v-model="Violation.ViolationDescription"
                        
                    />
                    
                    
               </CRow>

            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp;ثبت تخلف</h4>

            </template>
            <template #footer>
                <CButton @click="DialogAddViolation = false" color="warning">انصراف</CButton>
                <CButton color="primary" @click="Violation_Insert()">&nbsp;&nbsp;افزودن</CButton>
            </template>
        </CModal>
        <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'sm'"
                :show.sync="DialogEditViolation"
        >
            <div style="direction: rtl;text-align: right">
                <CRow>
                    <CSelect  label="انتخاب خط"   :options="GetOtions($store.state.Fleets.RequestResponse)"   :value.sync="SelectViolation.FleetID" @change="ChangeFleet2"   style="color: white" > </CSelect>
                    <CSelect  label="انتخاب خودرو"    :options="GetOtionsDevice2($store.state.Devices.RequestResponse)"  :value.sync="SelectViolation.DeviceID"   style="color: white" > </CSelect>
                    <CSelect label="نوع تخلف" :options="GetOtionsViolation($store.state.ViolationList_GetAll.RequestResponse)"   :value.sync="SelectViolation.ViolationID"    style="color: white" > </CSelect>
                    <label  for="stTime" style="color:white">زمان تخلف</label> 
                    <date-picker style="width:330px;" v-model="SelectViolation.ViolationTS"  id="stTime"  aria-label="تاریخ" auto-submit  type="datetime"></date-picker>
                    <CTextarea
                        label="توضیحات"
                        valid-feedback=""
                        invalid-feedback="حداقل چهار  کارکتر  می باشد."
                        value="Valid value"
                        rows="4"
                        v-model="SelectViolation.ViolationDescription"
                        
                    />
                    
                    
               </CRow>

            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp;ثبت تخلف</h4>

            </template>
            <template #footer>
                <CButton @click="DialogEditViolation = false" color="warning">انصراف</CButton>
                <CButton color="primary" @click="UpdateViolation()">&nbsp;&nbsp;بروزرسانی</CButton>
            </template>
        </CModal>
        <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'lg'"
                :show.sync="DialogAddGroupViolation"
        >
            <div style="direction: rtl;text-align: right">
                <CRow style="margin-right:0;margin-left:0;">
                    <CRow style="margin-right:0;margin-left:0;gap:10px">
                        <CCol >
                            <CRow style="margin-right:0;margin-left:0;"> 
                                <h5 style="color:white">خودروها</h5>
                            </CRow>
                            <CRow style="margin-right:0;margin-left:0;">
                                <input class="form-control" placeholder="فیلتر"  v-model="txtDevice" type="text"   aria-describedby="basic-addon1">
                            </CRow>
                            <CRow style="margin-right:0;margin-left:0;">
                                <select class="form-select"  size="10"    v-model="indexDevice">
                                    <option v-for="(device,index) in FilterDevice(txtDevice)" :value="index" v-text="device.CurrVehicleName"  v-bind:key="index"></option>
                                </select>
                            </CRow>
                        </CCol>
                        <CCol style="max-width: 100px;display:flex;align-items:center">
                            <div style="max-width: 100px;display:flex;flex-direction:column;gap:10px;margin:0 auto">
                                <CButton  color="success" @click="Add"> انتخاب</CButton>
                                <CButton  color="danger" @click="Revoke">حذف</CButton>
                            </div>
                        </CCol>

                        <CCol>
                            <CRow style="margin-right:0;margin-left:0;">
                                <h5 style="color:white">انتخاب شده</h5>
                            </CRow>
                            <CRow style="margin-right:0;margin-left:0;">
                                <input class="form-control"  placeholder="فیلتر" v-model="txtDeviceSelect" type="text"   aria-describedby="basic-addon1">
                            </CRow>
                            <CRow style="margin-right:0;margin-left:0;">
                                <select class="form-select"   size="10"    v-model="indexDeviceSelect">
                                    <option v-for="(device,index) in FilterDeviceSelect(txtDeviceSelect)" :value="index" v-text="device.CurrVehicleName" v-bind:key="index"></option>
                                </select>
                            </CRow>
                        </CCol>
                    </CRow>
                    
                    <CSelect label="نوع تخلف" :options="GetOtionsViolation($store.state.ViolationList_GetAll.RequestResponse)"   :value.sync="Violation.ViolationID"    style="color: white" > </CSelect>
                    <label for="stTime" style="color:white">زمان تخلف</label> 
                    <date-picker style="width:330px;" v-model="Violation.ViolationTS"  id="stTime"  aria-label="تاریخ" auto-submit  type="datetime"></date-picker>
                    <CTextarea
                        label="توضیحات"
                        valid-feedback=""
                        invalid-feedback="حداقل چهار  کارکتر  می باشد."
                        value="Valid value"
                        rows="4"
                        v-model="Violation.ViolationDescription"
                        
                    />
                    
                    
                    
               </CRow>

            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp;ثبت تخلف</h4>

            </template>
            <template #footer>
                <CButton @click="DialogAddGroupViolation = false" color="warning">انصراف</CButton>
                <CButton color="primary" @click="AddAll()">&nbsp;&nbsp;افزودن</CButton>
            </template>
        </CModal>
    </div>
</template>

<script>
import Vue from 'vue'
    export default {
        name: "Pages",
        data(){
            return {
                fields:[{key:'Rows',label:'ردیف'},{key:'VehicleName',label:'نام خودرو'},{key:'DriverName',label:'نام راننده'},{key:'ViolationName',label:'عنوان تخلف'},{key:'ViolationTS',label:'تاریخ'},{key:'Edit',label:'ویرایش'},{key:'Delete',label:'حذف'}],
                DialogAddViolation:false,
                DialogEditViolation:false,
                DialogAddGroupViolation:false,
                Devices:[],
                LastDevices:[],
                SelectDevices:[],
                indexDevice:-1,
                indexDeviceSelect:-1,
                txtDevice:'',
                txtDeviceSelect:'',
                Violation:{
                    ViolationID:0,
                    ViolationTS:'',
                    indexDeviceID:0,
                    VehicleName:'',
                    FleetID:0,
                    DriverID:0,
                    DriverName:'',
                    ViolationDescription:'',
                },
                LastViolation:{},
                SelectViolation:{},
            }
        },
        computed:{
            ReadViolation_Insert(){
                return this.$store.state.Violation_Insert;
            },
            ReadViolation_Delete(){
                return this.$store.state.Violation_Delete;
            },
            ReadDevices(){
                return this.$store.state.Devices;
            },
        },
        watch:{
            ReadViolation_Insert(res){
                 if(res.Status!==undefined){
                    if(res.Status){
                        if(res.RequestResponse[0].Message==='Successfully!'){
                            this.Violation_GetTop10ByUserID();
                            this.DialogAddViolation=false;
                            this.DialogEditViolation=false;
                            this.$store.commit('ShowToast',{type:'success',message:'عملیات با موفقیت انجام شد.'})
                        }
                        
                    }
                    
                }
            },
            ReadViolation_Delete(res){
                if(res.Status!==undefined){
                    if(res.Status){
                        if(res.RequestResponse[0].Message==='Successfully!'){
                            this.Violation_GetTop10ByUserID();
                            this.$store.commit('ShowToast',{type:'success',message:'عملیات با موفقیت انجام شد.'})
                        }
                        
                    }
                }
            },
            ReadDevices(res){
                if(res.Status!==undefined){
                    if(res.Status){
                        if(res.RequestResponse.length>0 && this.LastDevices.length===0){
                            this.Devices=res.RequestResponse;
                            this.LastDevices=res.RequestResponse;
                        }                        
                    }
                }
                
            },
        },
        mounted(){
            this.GetFleets();
            this.GetDeviceWithUserID();
            this.ViolationList_GetAll();
            this.Violation_GetTop10ByUserID();
            var timeNow=Vue.moment().format('YYYY-MM-DD HH:mm:ss');
            this.Violation.ViolationTS=Vue.moment(timeNow, "YYYY-MM-DD HH:mm:ss").format("jYYYY-jMM-jDD HH:mm:ss");
        },
        methods:{
            ViolationList_GetAll(){
                this.$store.commit('ViolationList_GetAll',{
                    UserID:2188
                });
            },
            GetDeviceWithUserID(){
                this.$store.commit('Device_GetAllByUserID')
            },
            Add(){
                if(this.indexDevice===-1)
                    return;
                var that=this;
                let newArray = this.Devices.filter(function(item)
                {
                    if(item.CurrVehicleName.includes(that.txtDevice))
                        return true;
                    else
                        return false;
                });
                this.SelectDevices.push(newArray[this.indexDevice]);
                this.Devices.splice(this.FindIndex(this.Devices,newArray[this.indexDevice]),1);
                this.indexDevice=-1;
            },
            
            FindIndex(arr,object){
                var index=-1;
                for(var i=0;i<arr.length;i++){
                    if(Object.is(arr[i], object)){
                        index=i;
                        break;
                    }
                }
                return index;
            },
            Revoke(){
                if(this.indexDeviceSelect===-1)
                    return;
                var that=this;
                let newArray = this.SelectDevices.filter(function(item)
                {
                    if(item.CurrVehicleName.includes(that.txtDeviceSelect))
                        return true;
                    else
                        return false;
                });
               
                 this.Devices.push(newArray[this.indexDeviceSelect]);
                this.SelectDevices.splice(this.FindIndex(this.SelectDevices,newArray[this.indexDeviceSelect]),1);
                 this.indexDeviceSelect=-1;
            },
            FilterDevice(serach){
                let newArray = this.Devices.filter(function(item)
                {
                    if(item.CurrVehicleName.includes(serach))
                        return true;
                    else
                        return false;
                });
                console.log()
                return newArray;
            },
            Edit(item){
               var time=Vue.moment(item.ViolationTS, "YYYY-MM-DD HH:mm:ss").format("jYYYY-jMM-jDD HH:mm:ss");
               //this.LastViolation=item;
               //this.SelectViolation.ViolationTS=time
               this.SelectViolation.ViolationTS=time
               this.SelectViolation.ViolationDescription=item.ViolationDescription
               this.SelectViolation.ViolationPriority=item.ViolationPriority
               this.SelectViolation.DeviceID=item.DeviceID
               this.SelectViolation.ViolationID=item.ViolationID
               this.SelectViolation.DriverName=item.DriverName
               this.SelectViolation.VehicleName=item.VehicleName
               this.SelectViolation.DriverID=item.DriverID
               this.SelectViolation.FleetID=item.FleetID
               this.LastViolation.DeviceID=item.DeviceID;
               this.LastViolation.ViolationTS=item.ViolationTS;
               this.LastViolation.ViolationID=item.ViolationID;
               this.ChangeFleet2();
               this.DialogEditViolation=true;
            },
            UpdateViolation(){
                this.Violation_Delete(this.LastViolation);
                var index=-1;
                for(var i=0;i<this.$store.state.Devices.RequestResponse.length;i++){
                    if(this.$store.state.Devices.RequestResponse[i].DeviceID===this.SelectViolation.DeviceID){
                        index=i;
                        break;
                    }
                }
                var time=Vue.moment(this.SelectViolation.ViolationTS, "jYYYY-jMM-jDD HH:mm:ss").format("YYYY_MM_DD_HH_mm_ss");
                var DeviceID=this.$store.state.Devices.RequestResponse[index].DeviceID;

                var VehicleName=this.$store.state.Devices.RequestResponse[index].CurrVehicleName;
                var CurrDriverName=this.$store.state.Devices.RequestResponse[index].CurrDriverName;
                var CurrDriverID=this.$store.state.Devices.RequestResponse[index].CurrDriverID;
                this.$store.commit('Violation_Insert',{
                    UserID:2188,
                    ViolationID:this.SelectViolation.ViolationID,
                    ViolationTS:time,
                    DeviceID:DeviceID,
                    VehicleName:VehicleName,
                    FleetID:this.SelectViolation.FleetID,
                    DriverID:CurrDriverID,
                    DriverName:CurrDriverName,
                    ViolationDescription:this.SelectViolation.ViolationDescription,
                });
            },
            FilterDeviceSelect(serach){
                console.log(this.SelectDevices)
                let newArray = this.SelectDevices.filter(function(item)
                {
                    if(item.CurrVehicleName.includes(serach))
                        return true;
                    else
                        return false;
                });
                return newArray;
            },
            AddAll(){
                if(this.Violation.ViolationID===0 || this.Violation.ViolationDescription.length===0){
                    this.$store.commit('ShowToast',{type:'error',message:'لطفا تمامی فیلد ها را پر کنید'});
                    return;
                }
                for(var i=0;i<this.SelectDevices.length;i++){
                    var time=Vue.moment(this.Violation.ViolationTS, "jYYYY-jMM-jDD HH:mm:ss").format("YYYY_MM_DD_HH_mm_ss");
                    
                    var DeviceID=this.SelectDevices[i].DeviceID;
                    var VehicleName=this.SelectDevices[i].CurrVehicleName;
                    var CurrDriverName=this.SelectDevices[i].CurrDriverName;
                    var CurrDriverID=this.SelectDevices[i].CurrDriverID;
                    var FleetID=this.SelectDevices[i].FleetID;
                    this.$store.commit('Violation_Insert',{
                        UserID:2188,
                        ViolationID:this.Violation.ViolationID,
                        ViolationTS:time,
                        DeviceID:DeviceID,
                        VehicleName:VehicleName,
                        FleetID:FleetID,
                        DriverID:CurrDriverID,
                        DriverName:CurrDriverName,
                        ViolationDescription:this.Violation.ViolationDescription,
                    });
                }
                this.SelectDevices=[];
                this.Devices=this.LastDevices;
                this.txtDeviceSelect='',
                this.txtDevice='',
                this.DialogAddGroupViolation=false;
            },
            Violation_Delete(item){
                var ts=item.ViolationTS
                ts=ts.replaceAll("-","_").replaceAll(":","_").replaceAll(" ","_").replaceAll(".","_")
                this.$store.commit('Violation_Delete',{
                    UserID:2188,
                    ViolationID:item.ViolationID,
                    ViolationTS:ts,
                    DeviceID:item.DeviceID,
                });
            },
            GetOtionsViolation(violations){
                var options=[];
                var all={value:0,label:'-- انتخاب کنید --',disabled:true};
                options.push(all);
                for(var i=0;i<violations.length;i++){
                    var violation=violations[i];
                    var option={value:violation.ViolationID,label:violation.ViolationName};
                    options.push(option);
                }
                return options;
            },
            GetFleets(){
                this.$store.commit('FleetByUser');
            },
            GetOtions(fleets){
                var options=[];
                var all={value:0,label:'-- انتخاب کنید --',disabled:true};
                options.push(all);
                for(var i=0;i<fleets.length;i++){
                    var fleet=fleets[i];
                    var option={value:fleet.FleetID,label:fleet.FleetName};
                    options.push(option);
                }
                return options;
            },
            ChangeFleet(){
                this.Violation.indexDeviceID=0;
                this.$store.commit('Device_GetByFleetID',{
                    FleetID:this.Violation.FleetID
                });
            },
            ChangeFleet2(){
                this.Violation.indexDeviceID=0;
                this.$store.commit('Device_GetByFleetID',{
                    FleetID:this.SelectViolation.FleetID
                });
            },
            GetOtionsDevice(devices){
                var options=[];
                var all={value:0,label:'-- انتخاب کنید --',disabled:true};
                options.push(all);
                for(var i=0;i<devices.length;i++){
                    var device=devices[i];
                    var option={value:i,label:device.CurrVehicleName};
                    options.push(option);
                }
                return options;
            },
            GetOtionsDevice2(devices){
                var options=[];
                var all={value:-1,label:'-- انتخاب کنید --',disabled:true};
                options.push(all);
                for(var i=0;i<devices.length;i++){
                    var device=devices[i];
                    var option={value:device.DeviceID,label:device.CurrVehicleName};
                    options.push(option);
                }
                return options;
            },
            Violation_GetTop10ByUserID(){
                this.$store.commit('Violation_GetTop10ByUserID',{
                    UserID:2188
                });
            },
            Violation_Insert(){
                if(this.$store.state.Devices.RequestResponse.length===0){
                    this.$store.commit('ShowToast',{type:'error',message:'لطفا تمامی فیلد ها را پر کنید'});
                    return;
                }
                var DeviceID=this.$store.state.Devices.RequestResponse[this.Violation.indexDeviceID].DeviceID;
                console.log(DeviceID)
                console.log(this.Violation.ViolationID)
                console.log(this.Violation.FleetID)
                if(DeviceID===0 || this.Violation.ViolationID===0 || this.Violation.FleetID===0){
                    this.$store.commit('ShowToast',{type:'error',message:'لطفا تمامی فیلد ها را پر کنید'});
                }
                else{
                    var time=Vue.moment(this.Violation.ViolationTS, "jYYYY-jMM-jDD HH:mm:ss").format("YYYY_MM_DD_HH_mm_ss");
                    
                    var VehicleName=this.$store.state.Devices.RequestResponse[this.Violation.indexDeviceID].CurrVehicleName;
                    var CurrDriverName=this.$store.state.Devices.RequestResponse[this.Violation.indexDeviceID].CurrDriverName;
                    var CurrDriverID=this.$store.state.Devices.RequestResponse[this.Violation.indexDeviceID].CurrDriverID;
                    this.$store.commit('Violation_Insert',{
                        UserID:2188,
                        ViolationID:this.Violation.ViolationID,
                        ViolationTS:time,
                        DeviceID:DeviceID,
                        VehicleName:VehicleName,
                        FleetID:this.Violation.FleetID,
                        DriverID:CurrDriverID,
                        DriverName:CurrDriverName,
                        ViolationDescription:this.Violation.ViolationDescription,
                    });
                }
                
            },
            Violation_Update(){
                if(this.$store.state.Devices.RequestResponse.length===0){
                    this.$store.commit('ShowToast',{type:'error',message:'لطفا تمامی فیلد ها را پر کنید'});
                    return;
                }
                var DeviceID=this.$store.state.Devices.RequestResponse[this.Violation.indexDeviceID].DeviceID;
                console.log(DeviceID)
                console.log(this.Violation.ViolationID)
                console.log(this.Violation.FleetID)
                if(DeviceID===0 || this.Violation.ViolationID===0 || this.Violation.FleetID===0){
                    this.$store.commit('ShowToast',{type:'error',message:'لطفا تمامی فیلد ها را پر کنید'});
                }
                else{
                    var time=Vue.moment(this.Violation.ViolationTS, "jYYYY-jMM-jDD HH:mm:ss").format("YYYY_MM_DD_HH_mm_ss");
                    
                    var VehicleName=this.$store.state.Devices.RequestResponse[this.Violation.indexDeviceID].CurrVehicleName;
                    var CurrDriverName=this.$store.state.Devices.RequestResponse[this.Violation.indexDeviceID].CurrDriverName;
                    var CurrDriverID=this.$store.state.Devices.RequestResponse[this.Violation.indexDeviceID].CurrDriverID;
                    this.$store.commit('Violation_Update',{
                        UserID:2188,
                        ViolationID:this.Violation.ViolationID,
                        ViolationTS:time,
                        DeviceID:DeviceID,
                        VehicleName:VehicleName,
                        FleetID:this.Violation.FleetID,
                        DriverID:CurrDriverID,
                        DriverName:CurrDriverName,
                        ViolationDescription:this.Violation.ViolationDescription,
                    });
                }
                
            },
            GetDateTime(time){
                return Vue.moment(time, "YYYY-MM-DD HH:mm:ss").format("jYYYY-jMM-jDD HH:mm");
            },
        }
    }
</script>

<style scoped>

</style>